<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入手机号或邮箱" v-model="keywords"  style="width:300px;" @change="getData" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>

        <!-- 商品列表 -->
        <div class="content">
            <el-table :data="tableData"  height="630" style="width: 100%">
                <el-table-column  prop="order.title" label="订单号" align="center"></el-table-column>
                <el-table-column  prop="user.phone" label="手机号" align="center"></el-table-column>
                <el-table-column  prop="user.email" label="邮箱" align="center"></el-table-column>
                <el-table-column  prop="" label="状态" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.gift_record">
                            <span v-if="scope.row.gift_record.status == 0" style="color:palegreen">未领取</span>
                            <span v-else style="color:red">已领取</span>
                        </div>
                        <div v-else style="color:#666;">礼品未发放</div>
                    </template>
                </el-table-column>
                <el-table-column  prop="coupon_record_count" label="操作" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.gift_record && scope.row.gift_record.status == 0" type="success" plain @click="handleGet(scope.row)">领取</el-button>
                    </template>
                </el-table-column>
                <el-table-column  prop="gift_record.use_time" label="领取时间" align="center"></el-table-column>
                <el-table-column  prop="gift_record.use_time" label="订单详情" align="center">
                    <template slot-scope="scope">
                        <el-button
                        @click="showDetail(scope.row)"
                        type="danger"
                        plain
                        size="mini"
                        >查看详情</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="loadPage" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </div>
        <!-- 展开商品详情弹框 -->
        <el-dialog
            title="订单详情"
            :visible.sync="detail_modal"
            :close-on-click-modal="false"
            center
            width="1200px"
            >
            <el-card class="m-bottom-4" style="position: relative;">
                <el-row class="m-bottom-2">
                <el-col :span="11" class="row-height"
                    >订单号码：{{ detail.title }}</el-col
                >
                <el-col :span="13" class="row-height"
                    >下单时间：{{ detail.created_at }}</el-col
                >
                </el-row>
                <el-row class="m-bottom-2">
                <el-col :span="13" v-if="detail.order_logistics" class="row-height"
                    >联 系 人：{{detail.order_logistics.surname + "-" + detail.order_logistics.name  }}</el-col
                >
                </el-row>
                <el-row class="m-bottom-2" v-if="detail.order_logistics">
                <el-col :span="11" class="row-height"
                    >联系电话：{{ detail.order_logistics.tel }}</el-col
                >
                <el-col :span="13" class="row-height"
                    >联系邮箱：{{ detail.order_logistics.email }}</el-col
                >
                </el-row>
                <el-row class="row-height">
                <el-col :span="13" class="row-height"
                    >收货方式：{{ detail.delivery_method_title }}</el-col
                >
                </el-row>
            </el-card>
            <el-card v-if="detail.title">
                <p
                    style="
                        text-align: right;
                        font-size: 16px;
                        font-weight: bold;
                        padding: 0 30px 10px 0;
                    "
                    >
                支付总价：{{ detail.order_total_amount }}
                </p>
            </el-card>
        </el-dialog>
    </section>
</template>



<script>

import {  gift_recode, receive } from '@/api/market.js'
export default {
    data() {
        return {
            keywords:'',
            page:1,
            total:0,
            size: 0,
            tableData:[],
            detail_modal: false,
            detail: {},
        }
    },
    methods: {
        search() {
            this.page = 1;
            this.getData()
        },
        getData() {
            let params = {
                page: this.page
            }
            if(this.keywords != '') {
                params.keywords = this.keywords
            }
            gift_recode(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                }
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
        // 领取
        handleGet(row) {
            receive(row.gift_record.id).then(res => {
                if(res) {
                    this.$message({type:'success', message: '领取成功'})
                    this.getData()
                }
            })
        },
        showDetail(row) {
            this.detail = row.order
            this.detail_modal = true;
        }
    },
    created(){
        this.getData()
    }
}
</script>

<style lang="less" scoped>

</style>


